export const WOD_TRACKS = [
    { value: "crossfit", label: "CrossFit" },
    { value: "engine", label: "Engine / Condicionamento" },
    { value: "weightlifting", label: "Weightlifting" },
    { value: "gymnastics", label: "Gymnastics" },
    { value: "competition", label: "Competição" },
    { value: "beginner", label: "Iniciante" },
];

export const WOD_COMPONENT_TYPES = [
    { value: "warmup", label: "Aquecimento" },
    { value: "skill", label: "Skill / Técnica" },
    { value: "strength", label: "Força" },
    { value: "gymnastics", label: "Ginástico" },
    { value: "metcon", label: "Metcon / WOD" },
    { value: "monostructural", label: "Cardio" },
    { value: "accessory", label: "Acessório" },
    { value: "mobility", label: "Mobilidade" },
];

export const WOD_FORMATS = [
    { value: "amrap", label: "AMRAP", scoreType: "rounds_reps", desc: "Maior número de rounds e reps em um tempo fixo." },
    { value: "emom", label: "EMOM", scoreType: "completion", desc: "Tarefa a cada minuto por tempo definido." },
    { value: "for_time", label: "For Time", scoreType: "time", desc: "Completar o trabalho no menor tempo possível." },
    { value: "rft", label: "RFT", scoreType: "time", desc: "Rounds for time com número de voltas definido." },
    { value: "tabata", label: "Tabata", scoreType: "reps", desc: "Intervalos curtos de trabalho e descanso." },
    { value: "chipper", label: "Chipper", scoreType: "time", desc: "Lista longa feita uma vez, normalmente em sequência." },
    { value: "ladder", label: "Ladder", scoreType: "reps", desc: "Progressão crescente ou decrescente de reps/carga." },
    { value: "interval", label: "Interval", scoreType: "reps", desc: "Blocos repetidos de trabalho e descanso." },
    { value: "strength", label: "Strength", scoreType: "load", desc: "Séries de força, levantamento ou técnica com carga." },
    { value: "skill", label: "Skill", scoreType: "quality", desc: "Prática técnica sem placar competitivo obrigatório." },
];

export const WOD_SCORE_TYPES = [
    { value: "time", label: "Tempo" },
    { value: "rounds_reps", label: "Rounds + reps" },
    { value: "reps", label: "Total de reps" },
    { value: "load", label: "Carga" },
    { value: "distance", label: "Distância" },
    { value: "calories", label: "Calorias" },
    { value: "completion", label: "Concluído" },
    { value: "quality", label: "Qualidade técnica" },
];

export const WOD_UNITS = [
    { value: "reps", label: "reps" },
    { value: "kg", label: "kg" },
    { value: "lb", label: "lb" },
    { value: "m", label: "m" },
    { value: "km", label: "km" },
    { value: "cal", label: "cal" },
    { value: "sec", label: "seg" },
    { value: "min", label: "min" },
    { value: "rounds", label: "rounds" },
];

export const DEFAULT_WOD_MOVEMENT = {
    type: "wod_movement",
    movement: "",
    movementId: "",
    category: "",
    reps: "",
    load: "",
    distance: "",
    calories: "",
    time: "",
    height: "",
    unit: "reps",
    notes: "",
    scaling: {
        rx: "",
        intermediate: "",
        beginner: "",
    },
};

export const getScoreTypeForWodFormat = (format) =>
    WOD_FORMATS.find(item => item.value === format)?.scoreType || "completion";
